import { t } from "@/i18n-js/instance";
import { Badge } from "@circle-react-uikit/Badge";
import { Typography } from "@circle-react-uikit/Typography";
import { Information } from "./Information";

interface InvitationLinkInformationProps {
  invitationLinkActive?: boolean;
  invitationLinkName?: string;
  membersCount?: number;
  paywallCouponString?: string;
  paywallString?: string;
  shouldShowPaywall?: boolean;
  spaceGroups?: string[];
  spaces?: string[];
}

export const InvitationLinkInformation = ({
  invitationLinkName,
  invitationLinkActive,
  membersCount,
  spaces,
  spaceGroups,
  shouldShowPaywall,
  paywallString,
  paywallCouponString,
}: InvitationLinkInformationProps) => {
  const badgeVariant = invitationLinkActive ? "success" : "default";
  return (
    <>
      <div className="flex gap-3">
        <Typography.LabelLg>{invitationLinkName}</Typography.LabelLg>
        <Badge variant={badgeVariant}>
          <div className="px-2 py-1">
            {invitationLinkActive
              ? t("invitation_links.summary.badge.active")
              : t("invitation_links.summary.badge.revoked")}
          </div>
        </Badge>
      </div>
      <div className="pt-1">
        <Typography.LabelSm color="text-dark">
          {t("invitation_links.members_joined", { count: membersCount })}
        </Typography.LabelSm>
      </div>

      <div className="flex pt-2">
        <Information
          tooltipText={spaces?.join(", ")}
          text={t("invitation_links.summary.spaces", { count: spaces?.length })}
          hide={(spaces?.length ?? 0) <= 0}
        />
        <Information
          tooltipText={spaceGroups?.join(", ")}
          text={t("invitation_links.summary.space_groups", {
            count: spaceGroups?.length,
          })}
          hide={(spaceGroups?.length ?? 0) <= 0}
        />
        <Information
          tooltipText={paywallString}
          text={t("invitation_links.summary.paywall")}
          hide={!shouldShowPaywall}
        />
        <Information
          tooltipText={paywallCouponString}
          text={t("invitation_links.summary.paywall_coupon")}
          hide={!shouldShowPaywall || !paywallCouponString}
        />
      </div>
    </>
  );
};
